import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';

import paginationParams from 'utils/pagination-params';

export const list = 'LIST_QUALIFICATION_QUESTIONS';
export const single = 'SINGLE_QUALIFICATION_QUESTION';

export const qualificationQuestionsApi = createApi({
  reducerPath: 'qualificationQuestionsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createQualificationQuestion: builder.mutation({
      query: (qualificationQuestion) => ({
        url: '/qualification-questions/create',
        method: 'POST',
        body: qualificationQuestion
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            qualificationQuestionsApi.util.updateQueryData('listQualificationQuestions', undefined, (draft) => {
              draft.data.items.unshift(created.data);
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateQualificationQuestion: builder.mutation({
      query: ({ qualificationQuestionId, ...attributes }) => ({
        url: `/qualification-questions/update/${qualificationQuestionId}`,
        method: 'POST',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ qualificationQuestionId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            qualificationQuestionsApi.util.updateQueryData('listQualificationQuestions', undefined, (draft) => {
              const qualificationQuestion = draft.data.items.find((question) => question.id === qualificationQuestionId);
              if (qualificationQuestion) {
                Object.assign(qualificationQuestion, updated.data);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    deleteQualificationQuestion: builder.mutation({
      query: (qualificationQuestionId) => ({
        url: `/qualification-questions/delete/${qualificationQuestionId}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            qualificationQuestionsApi.util.updateQueryData('listQualificationQuestions', undefined, (draft) => {
              const idx = draft.data.items.findIndex((item) => item.id === id);
              if (idx > -1) {
                draft.data.items.splice(idx, 1);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getQualificationQuestionById: builder.query({
      query: (qualificationQuestionId) => `/qualification-questions/get/${qualificationQuestionId}`,
      providesTags: [single]
    }),
    listQualificationQuestions: builder.query({
      query: (params) => ({
        url: '/qualification-questions/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const {
  useCreateQualificationQuestionMutation,
  useUpdateQualificationQuestionMutation,
  useDeleteQualificationQuestionMutation,
  useGetQualificationQuestionByIdQuery,
  useListQualificationQuestionsQuery
} = qualificationQuestionsApi;
